import { Button } from '../Button'
import { IButtonSwitcherProps } from './ButtonSwitcher.types'
import css from './ButtonSwitcher.module.scss'

export const ButtonSwitcher = ({
  className,
  isBlock,
  options,
  selectedValue,
  onSelect,
}: IButtonSwitcherProps) => {
  return (
    <div
      className={`${css.root} ${isBlock ? css.isBlock : ''} ${className || ''}`}
    >
      {options.map(({ value, label, ...passingProps }) => {
        const isSelected = value === selectedValue

        return isSelected ? (
          <Button.Primary
            key={`${label}_${value}`}
            onClick={() => onSelect(value)}
            type="button"
            className={css.selectedButton}
            {...passingProps}
          >
            {label}
          </Button.Primary>
        ) : (
          <Button.Secondary
            key={`${label}_${value}`}
            onClick={() => onSelect(value)}
            type="button"
            className={css.notSelectedButton}
            {...passingProps}
          >
            {label}
          </Button.Secondary>
        )
      })}
    </div>
  )
}
